import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  /* background: rgba(0,0,0,0.4); */
  z-index: 10009;
`;

export const Container = styled.div`
  position: fixed;
  display: flex;
  padding: 4rem 3%;
  flex-direction: column;

  top: 6.5vh;
  left: 0;
  width: 22%;
  height: 100vh;

  background-color: var(--dark-blue);
  color: var(--white);

  z-index: 10009;

  display: flex;
  flex-direction: column;
  gap: 3vh;

  animation: slideIn 0.2s ease;

  @keyframes slideIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @media (max-width: 768px) {
    width: 100%;

  }

`;

export const LinkContainer = styled.div<{ $active?: boolean }>`
    padding: 2px 0;

    img{
        width: 24px;
        height: 24px;
        filter:${({ $active }) => $active ? "invert(40%) sepia(80%) saturate(2000%) hue-rotate(200deg)" : "none"};
    }

    h1{
        font-size: 1.1rem;
        font-weight: 500;
    }
    cursor: pointer;
    display: flex;
    gap: 15px;
    color: ${({ $active }) => ($active ? "var(--light-blue)" : "white")};
    
    &:hover {
        background-color: var(--hover);
    }
`;

export const History = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
    h1{
        font-size: 1.5rem;
        color: var(--white);
        align-self: left;
    }

    h2{
        font-size: 1.3rem;
        font-weight: 500;
        cursor: pointer;
        align-self: left;
    }

    h2.active {
      color: var(--light-blue);
    }

   .historyTitles {
        display: flex;
        flex-direction: column;
        gap: 25px;

        max-height: 32vh;
        overflow-y: auto;
        overflow-x: hidden;

        padding-right: 10px;

        scrollbar-width: thin;
        scrollbar-color: var(--gray) transparent;
    }

   

`;

export const HistoryItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    padding: 2px 4px;

    h2 {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 1.1rem;
        font-weight: 500;
        cursor: pointer;
    }

    img {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        cursor: pointer;
        opacity: 0.6;
        transition: opacity 0.15s ease;
        filter: invert(100%) saturate(200%) brightness(150%) ;
    }
    &:hover {
        background-color: var(--hover);
    }
   
    img:hover {
        opacity: 1;
    }
    img:hover::after{
        
        position: absolute;
        background: var(--light-gray);
        padding: 5px 10px;
        border-radius: 2px;
        font-size: 0.9rem;
        color: var(--black);
    }
`;

export const NewConversation = styled.div`
    display: flex;
    
    gap: 8px;
    cursor: pointer;
    color: var(--white);
    transition: color 0.15s ease;

    img {
        width: 22px;
        height: 22px;
        filter: invert(100%) sepia(100%) saturate(100%) brightness(200%) contrast(200%);
    }
    h2 {
        font-size: 1.1rem;
        font-weight: bold;
        
    }
    &:hover {
        background-color: var(--hover);
    }
`;

export const DeleteButton = styled.button`
    position: relative;
    display: flex;
    flex-shrink: 0;
    cursor: pointer;
    background: none;
    border: none;

    img {
        width: 20px;
        height: 20px;
        filter: brightness(0) invert(1);
    }
    &:hover img {
        opacity: 1;
    }

`;